export function transposeArray(array) {
  return array[0].map((_, colIndex) => array.map((row) => row[colIndex]));
}

export function binarySearch(ar, el, compare_fn) {
  let m = 0;
  let n = ar.length - 1;

  while (m <= n) {
    let k = (n + m) >> 1;
    let cmp = compare_fn(el, ar[k]);

    if (cmp > 0) {
      m = k + 1;
    } else if (cmp < 0) {
      n = k - 1;
    } else {
      return k;
    }
  }

  return -m - 1;
}

export function compare_number(a, b) {
  return a - b;
}

export function haversineDistance(mk1, mk2) {
  const R = 6371000; // Radius of the Earth in m
  const rlat1 = mk1[1] * (Math.PI / 180); // Convert degrees to radians
  const rlat2 = mk2[1] * (Math.PI / 180); // Convert degrees to radians
  const difflat = rlat2 - rlat1; // Radian difference (latitudes)
  const difflon = (mk2[0] - mk1[0]) * (Math.PI / 180); // Radian difference (longitudes)
  return (
    2 *
    R *
    Math.asin(
      Math.sqrt(
        Math.sin(difflat / 2) * Math.sin(difflat / 2) +
          Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)
      )
    )
  );
}

export function shoot(lon, lat, azimuth, maxdist = 500) {
  let glat1 = (lat * Math.PI) / 180;
  let glon1 = (lon * Math.PI) / 180;
  let s = maxdist / 1.852;
  let faz = (azimuth * Math.PI) / 180;

  const EPS = 0.00000000005;

  if (Math.abs(Math.cos(glat1)) < EPS && !(Math.abs(Math.sin(faz)) < EPS)) {
    alert('Only N-S courses are meaningful, starting at a pole!');
  }

  let a = 6378.13 / 1.852;
  let f = 1 / 298.257223563;
  let r = 1 - f;
  let tu = r * Math.tan(glat1);
  let sf = Math.sin(faz);
  let cf = Math.cos(faz);

  let b = cf === 0 ? 0 : 2 * Math.atan2(tu, cf);

  let cu = 1 / Math.sqrt(1 + tu * tu);
  let su = tu * cu;
  let sa = cu * sf;
  let c2a = 1 - sa * sa;
  let x = 1 + Math.sqrt(1 + c2a * (1 / (r * r) - 1));
  x = (x - 2) / x;
  let c = 1 - x;
  c = ((x * x) / 4 + 1) / c;
  let d = (0.375 * x * x - 1) * x;
  tu = s / (r * a * c);
  let y = tu;
  c = y + 1;

  let sy = 0;
  let cy = 0;
  let cz = 0;
  let e = 0;

  while (Math.abs(y - c) > EPS) {
    sy = Math.sin(y);
    cy = Math.cos(y);
    cz = Math.cos(b + y);
    e = 2 * cz * cz - 1;
    c = y;
    x = e * cy;
    y = e + e - 1;
    y = (((((sy * sy * 4 - 3) * y * cz * d) / 6 + x) * d) / 4 - cz) * sy * d + tu;
  }

  b = cu * cy * cf - su * sy;
  c = r * Math.sqrt(sa * sa + b * b);
  d = su * cy + cu * sy * cf;
  let glat2 = ((Math.atan2(d, c) + Math.PI) % (2 * Math.PI)) - Math.PI;
  c = cu * cy - su * sy * cf;
  x = Math.atan2(sy * sf, c);
  c = (((-3 * c2a + 4) * f + 4) * c2a * f) / 16;
  d = ((e * cy * c + cz) * sy * c + y) * sa;
  let glon2 = ((glon1 + x - (1 - c) * d * f + Math.PI) % (2 * Math.PI)) - Math.PI;

  let baz = (Math.atan2(sa, b) + Math.PI) % (2 * Math.PI);

  glon2 *= 180 / Math.PI;
  glat2 *= 180 / Math.PI;
  baz *= 180 / Math.PI;

  if (Math.abs(lon - glon2)>180) {
    if (lon>glon2){
      glon2 = glon2 + 360
    } else {
      glon2 = glon2 - 360
    }
  }
  return [glon2, glat2, baz];
}
